import React, { useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Select from 'react-select';
import API from '../../api/axios';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useQuery } from 'react-query';

const SelectStates = React.memo(
  ({
    isMulti = false,
    onSelect,
    placeholder = 'انتخاب استان',
    state = null,
    isDisabled = false,
    width = '100%',
    height = 56,
    isClearable = true,
    hasLabel = false,
    error = false,
    helperText = '',
    ...rest
  }) => {
    const [states, setStates] = useState(null);

    const loadStates = async () => {
      const url = `/api/v1/admin/state/list`;
      try {
        // const { data } = await API.get(url);
        const res = await fetch('/states.json');
        const data = await res.json();
        return data;
        setStates(data);
      } catch (err) {
        console.error(err);
      }
    };
    const handleSelectState = (state) => {
      onSelect(state);
    };
    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        zIndex: 100,
      }),
      control: (provided, state) => ({
        ...provided,
        height,
        width,
      }),
    };

    // useEffect(() => {
    //   loadStates();
    // }, []);

    const { data, isLoading } = useQuery('loadStatesAdminPanel', loadStates, {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 60 * 24 * 30,
      cacheTime: Infinity,
    });
    return (
      <>
        {!isLoading ? (
          <div style={{ position: 'relative' }}>
            <Select
              options={data.map((state) => ({
                label: state.title,
                value: state._id,
              }))}
              isMulti={isMulti}
              isSearchable={true}
              placeholder={placeholder}
              value={state}
              onChange={(option) => handleSelectState(option)}
              noOptionsMessage={() => 'استانی یافت نشد!'}
              isDisabled={isDisabled}
              isClearable={isClearable}
              styles={customStyles}
              {...rest}
            />
            {state && hasLabel && (
              <label
                style={{
                  position: 'absolute',
                  top: -8,
                  right: 10,
                  fontSize: 12,
                  color: 'gray',
                  background: '#fff',
                  padding: '0 5px',
                }}
              >
                {placeholder}
              </label>
            )}
            <FormHelperText error={error}>{helperText}</FormHelperText>
          </div>
        ) : (
          <Skeleton
            height={height}
            animation="wave"
            variant="rect"
            width={width}
          />
        )}
      </>
    );
  }
);

export default React.memo(SelectStates);
